import "./PageHeader.scss"

/**
 * Compact page intro used under PanelLayout titles (or standalone).
 */
const PageHeader = ({ title, subtitle, extra, className = "" }) => {
  if (!title && !subtitle && !extra) return null
  return (
    <div className={`page-intro ${className}`.trim()}>
      <div className="page-intro__copy">
        {title ? <h2 className="page-intro__title">{title}</h2> : null}
        {subtitle ? <p className="page-intro__subtitle">{subtitle}</p> : null}
      </div>
      {extra ? <div className="page-intro__extra">{extra}</div> : null}
    </div>
  )
}

export default PageHeader
